import { useContext } from "react";
import { CustomerContext } from "../../providers";
import { EmbeddedGuideflow } from "../EmbeddedGuideflow";
import { Button } from "../tailwind/button";
import { Field, Fieldset } from "../tailwind/fieldset";
import { Text } from "../tailwind/text";

export const CollectOptins = () => {
  const { integrations } = useContext(CustomerContext);
  const titleClasses = "font-bold";
  const fieldClasses = "mb-2";

  return (
    <div className="relative">
      <Fieldset>
        {integrations.shopify && (
          <Field className={fieldClasses}>
            <Text className={titleClasses}>Shopify</Text>
            <Text>Add a checkbox at checkout to collect optins</Text>
            <div>
              <EmbeddedGuideflow id="9r2vv8azk6" />
            </div>
          </Field>
        )}
        {integrations.klaviyo && (
          <Field className={fieldClasses}>
            <Text className={titleClasses}>Klaviyo</Text>
            <Text>Use your email popup to collect phone numbers</Text>
            <Button
              color="secondaryButton"
              className="mt-1"
              onClick={() =>
                window.open(
                  "https://help.getsimio.com/fr_FR/collecter-via-klaviyo/%F0%9F%97%B3%EF%B8%8F-%5Bklaviyo%5D-collecte-via-une-popup",
                  "_blank",
                )
              }
            >
              See documentation
            </Button>
          </Field>
        )}
        <Field className={fieldClasses}>
          <Text className={titleClasses}>Custom</Text>
          <Text>
            You can start collecting optins on your website with a checkbox and
            a popup.
          </Text>
        </Field>
      </Fieldset>
    </div>
  );
};
